/**
 * StructuredLogAdapter.ts - StructuredLogAdapter
 * 
 * CHANGE HISTORY:
 * - 251021_0517 [8786ca9] danielbeer: feat: apply authr pattern to all 43 remaining packages
 * - 251021_0447 [ce7b5e6] danielbeer: feat: automate TypeScript and Actr integration for all packages
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import { LogLevel } from '../models/LogEntry';

export class StructuredLogAdapter {
    options: Record<string, unknown>;
  buffer: any;
  flushTimer: any;

  constructor(options = {}) {
    this.options = {
      minLevel: options.minLevel !== undefined ? options.minLevel : LogLevel.INFO,
      endpoint: options.endpoint || '/api/logs',
      batchSize: options.batchSize || 10,
      flushInterval: options.flushInterval || 5000, // 5 seconds
      service: options.service || 'opcentral',
      environment: options.environment || 'development',
      ...options
    };
    
    this.buffer = [];
    this.flushTimer = null;
    
    // Start flush timer
    this.startFlushTimer();
  }
  
  /**
   * Write log entry
   */
  async write(logEntry) {
    if (!logEntry.isLevelEnabled(this.options.minLevel)) {
      return;
    }
    
    const structuredLog = {
      ...logEntry.toStructuredLog(),
      service: this.options.service,
      environment: this.options.environment
    };
    
    this.buffer.push(structuredLog);
    
    // Flush if buffer is full
    if (this.buffer.length >= this.options.batchSize) {
      await this.flush();
    }
  }
  
  /**
   * Flush buffer to endpoint
   */
  async flush() {
    if (this.buffer.length === 0) return;
    
    const logs = [...this.buffer];
    this.buffer = [];
    
    try {
      await fetch(this.options.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ logs })
      });
    } catch (error) {
      console.error('Failed to send structured logs:', error);
      // Re-add to buffer on failure
      this.buffer.unshift(...logs);
    }
  }
  
  /**
   * Start flush timer
   */
  startFlushTimer(): any {
    this.flushTimer = setInterval(() => {
      this.flush();
    }, this.options.flushInterval);
  }
  
  /**
   * Stop flush timer
   */
  stopFlushTimer(): any {
    if (this.flushTimer) {
      clearInterval(this.flushTimer);
      this.flushTimer = null;
    }
  }
  
  /**
   * Close adapter
   */
  async close() {
    this.stopFlushTimer();
    await this.flush();
  }
}

export default StructuredLogAdapter;
